<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="$t('Pricing.Audit')"
    width="900px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    top="5vh"
    custom-class="details-view air-markup"
  >
    <div class="price-dialog-header">
      <div>
        <el-button no="onOK" type="primary" @click="onOK">{{ $t('Pricing.CONFIRM') }}</el-button>
        <el-button no="onReset" @click="onReset">{{ $t('Pricing.Reset') }}</el-button>
        <el-button no="onCancel" @click="onCancel">{{ $t('Pricing.Back') }}</el-button>
      </div>
    </div>
    <air-markup ref="airMarkUp" />
  </el-dialog>
</template>

<script>
import LocalStorageUtils from '@/utils/localStorageUtils'
import * as CommonUtil from '@/utils/commonUtil'
import { getLoading } from '@/utils/utilBaseElement'
import { approvePriceAirsWithAllTiers } from '@/api/price/priceAir'
import AirMarkup from '@/views/cargo/v0/Price/PriceAir/components/airMarkup'

export default {
  name: 'AirMarkupPopup',
  components: { AirMarkup },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    configUtil: {
      type: Object,
      default: () => {
      }
    },
    keys: {
      type: Array,
      default: () => []
    },
    selectedRows: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      fullscreenLoading: null,
      markupLocked: false
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    }
  },
  methods: {
    readConfig() {
      const source = LocalStorageUtils.getConfiguration('AirMarkup')
      if (source) {
        CommonUtil.objCopy(this.markup, source)
        this.setConfigFromLocalCache(this.markup)
      }
      this.markupLocked = this.configUtil.markupLocked
      if (this.markupLocked) {
        this.setConfigFromServer()
      }
    },
    setConfigFromLocalCache(source) {
      if (source == null) return
      if (!this.markupLocked) {
        this.$nextTick(() => {
          this.$refs['airMarkUp'].readConfig(source)
        })
      }
    },
    setConfigFromServer() {
      const source = this.configUtil.markupCfgValue
      if (!source) return
      this.$nextTick(() => {
        this.$refs['airMarkUp'].readConfig(source, true)
      })
    },
    onOK() {
      if (!this.markupLocked) {
        LocalStorageUtils.setConfiguration('AirMarkup', this.markup)
      }
      if (this.$refs['airMarkUp'].isValid()) {
        const params = this.$refs['airMarkUp'].getParams()
        params['priceAirUuids'] = this.keys
        this.fullscreenLoading = getLoading()
        approvePriceAirsWithAllTiers(params).then(res => {
          this.fullscreenLoading.close()
          this.$emit('approveSuccess', this.selectedRows)
          this.$emit('close')
        }).catch(e => {
          this.fullscreenLoading.close()
        })
      }
    },
    onCancel() {
      this.$emit('close')
    },
    onReset() {
      this.$refs['airMarkUp'].reset()
    }
  }
}
</script>

<style scoped>

</style>
